



































































































import Vue from 'vue'
import {
  AnonymizationConfigInputValue,
  AnonymizationConfigItem,
  AnonymizationMethod,
  Anonymizer,
} from '@qurit/anonymizer'
import { DcmjsDataSet } from '@qurit/anonymizer'

export default Vue.extend({
  props: [
    'datasets',
    'encapsulatedDatasets',
    'configItems',
    'encapsulatedConfigItems',
    'constants',
    'patientVariableValues',
    'encapsulatedPatientVariableValues',
    'trialCenterId',
  ],
  data() {
    return {
      index: 0,
      filteredDataset: [] as DcmjsDataSet[],
      encapsulatedFileItems: [
        'DocumentTitle',
        'SOPInstanceUID',
        'StudyDate',
        'ContentDate',
        'AcquisitionDateTime',
        'StudyTime',
        'ContentTime',
        'Modality',
        'ConversionType',
        'StudyInstanceUID',
        'SeriesInstanceUID',
        'SeriesNumber',
        'InstanceNumber',
      ] as string[],
      hint: "Review the anonymized values before uploading. Click 'Close' to go back to editing input values, click 'Finish Upload' to finish uploading.",
    }
  },
  methods: {
    filterDatasets() {
      const toReturn = [] as DcmjsDataSet[]
      const ds: Map<string, DcmjsDataSet[]> = this.datasets
      for (let value of ds.values()) {
        toReturn.push(value[0])
      }
      this.filteredDataset = toReturn
    },
    filterConfigItems(dataset: DcmjsDataSet) {
      return this.configItems.filter(
        (c: AnonymizationConfigItem) =>
          dataset.getElementFromConfig(c) ||
          c.method === AnonymizationMethod.Param
      )
    },
    anonymizeElement(
      configItem: AnonymizationConfigItem,
      dataset: DcmjsDataSet,
      patientVariableValues: Map<any, any>,
      configItems: AnonymizationConfigItem[],
      constants: Map<string, AnonymizationConfigInputValue> = new Map()
    ) {
      const value = dataset.getElementFromConfig(configItem)
      // Return blank if the patient's variable values not found
      // May occur after anonymization if the patient id becomes anonymized
      if (!patientVariableValues.get(dataset.getPatientId())) {
        return ''
      }
      try {
        const anonymizer = new Anonymizer(
          configItems,
          constants,
          patientVariableValues.get(dataset.getPatientId()) ?? new Map(),
          this.trialCenterId,
          process.env.ORG_ROOT
        )
        return anonymizer.anonymizeElement(configItem, value)
      } catch (error) {
        this.$toast.error(error.message)
        throw error
      }
    },
    handleUploadClick() {
      this.$emit('upload')
    },
    setDocTitle() {
      for (const dataset of this.encapsulatedDatasets.values()) {
        const patientId = this.anonymizeElement(
          this.encapsulatedConfigItems.find(
            (configItem: AnonymizationConfigItem) =>
              configItem.elementName == 'PatientID'
          ),
          dataset,
          this.encapsulatedPatientVariableValues,
          this.encapsulatedConfigItems
        )
        const seriesDescription = this.anonymizeElement(
          this.encapsulatedConfigItems.find(
            (configItem: AnonymizationConfigItem) =>
              configItem.elementName == 'SeriesDescription'
          ),
          dataset,
          this.encapsulatedPatientVariableValues,
          this.encapsulatedConfigItems
        )
        // set doc title, hardcoded to max 35 char len
        const title = patientId + '-' + seriesDescription
        dataset.setDocumentTitle(title.substring(0, 35) + '.pdf')
      }
    },
  },
})
